(() => {
  const brhOfferCard = () => {
    const selectors = {
      component: "js-offer-card",
    };

    const init = () => {
      const parentElement = Array.from(document.getElementsByClassName(selectors.component));
      if (parentElement) {
        parentElement.forEach((element) => {
          const mobileItems = element.querySelectorAll(".text-mobile-JS");
          const desktopItems = element.querySelectorAll(".text-desktop-JS");

          if (mobileItems && window.innerWidth < 1024) {
            mobileItems.forEach((e) => {
              e.classList.remove("hidden");
            });
          } else {
            mobileItems.forEach((e) => {
              e.classList.add("hidden");
            });
          }

          if (desktopItems && window.innerWidth > 1024) {
            desktopItems.forEach((e) => {
              e.classList.remove("hidden");
            });
          } else {
            desktopItems.forEach((e) => {
              e.classList.add("hidden");
            });
          }

          window.addEventListener("resize", () => {
            if (mobileItems && window.innerWidth < 1024) {
              mobileItems.forEach((e) => {
                e.classList.remove("hidden");
              });
            } else {
              mobileItems.forEach((e) => {
                e.classList.add("hidden");
              });
            }

            if (desktopItems && window.innerWidth > 1024) {
              desktopItems.forEach((e) => {
                e.classList.remove("hidden");
              });
            } else {
              desktopItems.forEach((e) => {
                e.classList.add("hidden");
              });
            }
          });
        });
      }
    };

    init();
  };
  document.addEventListener("DOMContentLoaded", brhOfferCard);
})();
